import { useLayoutEffect, useState } from 'react';
import { META_EVENTS, PRICES_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import { PricePreview } from '../lib/widget/prices/prices.interface';

const usePrices = () => {
  const { Widget } = window;
  const [state, setState] = useState<{
    pricesPreview: Array<PricePreview>;
    sectorSelected: boolean;
  }>({
    pricesPreview: [],
    sectorSelected: false,
  });
  const { isPeriodical } = Widget.metaController.meta;

  useLayoutEffect(() => {
    Widget.pricesController.addListener(PRICES_EVENTS.UPDATE, updatePreview);
    Widget.pricesController.addListener(PRICES_EVENTS.PRICES_PREVIEW_UPDATED, updatePreview);
    Widget.metaController.addListener(META_EVENTS.CHANGE_SECTOR, changeSector);

    return () => {
      Widget.pricesController.addListener(PRICES_EVENTS.UPDATE, updatePreview);
      Widget.pricesController.addListener(PRICES_EVENTS.PRICES_PREVIEW_UPDATED, updatePreview);
      Widget.metaController.addListener(META_EVENTS.CHANGE_SECTOR, changeSector);
    };
  }, []);

  const updatePreview = () => {
    setState((prevState) => ({
      ...prevState,
      pricesPreview: Widget.pricesController.pricesPreview,
    }));
  };

  const changeSector = (sector) => {
    setState((prevState) => ({ ...prevState, sectorSelected: !!sector }));
  };

  return {
    ...state,
    isPeriodical,
    withoutRendering:
      !state.pricesPreview.length ||
      state.pricesPreview.length === 1 ||
      (!Widget.schemeMode && !state.sectorSelected),
  };
};

export default usePrices;
